"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactRedux = require("react-redux");

var _actions = require("./redux/actions");

var _Banner = _interopRequireDefault(require("../common/Banner"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = (0, _reactRedux.connect)(null, {
  removeAction: _actions.removeBanner,
  updateAction: _actions.updateBanner,
  toggleAction: function toggleAction(id) {
    return (0, _actions.toggleCollapse)('Banner', id);
  }
})(_Banner["default"]);

exports["default"] = _default;